export default "__VITE_ASSET__CBsVsH$7__"